const api_url = process.env.NODE_ENV ===  "development" ? "http://localhost:8000/api/v1" : "https://fly247-api-849433205741.asia-south1.run.app/api/v1" ;
export default api_url;
